import classNames from 'classnames';

import css from './Table.css';

interface TableProps extends Pick<React.ComponentProps<'table'>, 'aria-labelledby' | 'className'> {
  children: React.ReactNode;
}

export const Table = ({ className, ...props }: TableProps) => (
  <table className={classNames(css.table, className)} {...props} />
);

interface CaptionProps {
  children: React.ReactNode;
  className?: string;
}

export const Caption = ({ children, className }: CaptionProps) => (
  <caption className={classNames(css.caption, className)}>{children}</caption>
);

interface TableHeadProps {
  children: React.ReactNode;
  className?: string;
}

export const TableHead = ({ children, className }: TableHeadProps) => (
  <thead className={classNames(css.header, className)}>{children}</thead>
);

interface TableBodyProps {
  children: React.ReactNode;
  className?: string;
}

export const TableBody = ({ children, className }: TableBodyProps) => <tbody className={className}>{children}</tbody>;

interface RowProps {
  children: React.ReactNode;
  className?: string;
}

export const Row = ({ children, className }: RowProps) => <tr className={className}>{children}</tr>;

interface HeaderCellProps {
  children: React.ReactNode;
  className?: string;
  scope?: 'col' | 'row';
}

export const HeaderCell = ({ children, className, scope }: HeaderCellProps) => (
  <th className={classNames(css.headerCell, className)} scope={scope}>
    {children}
  </th>
);

interface CellProps {
  children?: React.ReactNode;
  className?: string;
  colSpan?: number;
}

export const Cell = ({ children, className, colSpan }: CellProps) => (
  <td className={classNames(css.cell, className)} colSpan={colSpan}>
    {children}
  </td>
);
